import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './BuildingPermissionCertificate.css';
import logo from "../../../../../assets/image/ipdc logo.png";
import star from "../../../../../assets/image/star.png";
import Button from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';
import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
import html2pdf from 'html2pdf.js';

const BuildingPermissionCertificate = () => {
  const location = useLocation();
  const permitData = location.state?.permitData || {};
  const printRef = useRef();
  const [coordinateData, setCoordinateData] = useState([
    { x: '722713.4793', y: '1307200.8227' },
    { x: '722716.9428', y: '1307201.3268' },
    { x: '722716.4388', y: '1307204.7902' },
    { x: '722827.5631', y: '1307220.9624' },
    { x: '722839.3137', y: '1307140.2197' },
    { x: '722724.6372', y: '1307124.1532' }
  ]);
  const [permitDrawing, setPermitDrawing] = useState(null);
  const [permitdrawing2, setPermitdrawing2] = useState(null);
  
  const [formData, setFormData] = useState({
    date: new Date().toLocaleDateString(),
    serialNo: permitData.id || '',
    nameOfIndustryPark: permitData.park_name || '',
    owner: 'Industrial Parks Development Corporation',
    lesseesName: '',
    sizeOfPlot: permitData.area ? `${permitData.area}` : '',
    titleDeedNo: '',
    addressCity: permitData.park_city || '',
    buildingPermitNo: permitData.id || '',
    permitIssueDate: permitData.requested_on ? new Date(permitData.requested_on).toLocaleDateString() : '',
    permitExpiryDate: permitData.expected_finishing_date ? new Date(permitData.expected_finishing_date).toLocaleDateString() : '',
    drawings: {
      architectural: true,
      structural: true,
      electrical: true,
      sanitary: true,
      electromechanical: false,
      telecom: false
    },
    coordinates: coordinateData,
    approvedBy: permitData.permit_issued_by || '',
    checkedBy: permitData.permit_registered_by || '',
    certifiedBy: 'Amanuel '
  });
   
  useEffect(() => {
    const fetchAllData = async () => {
      if (!permitData.agreement_id) return;
      
      try {
        const allbuildingpermit = await GetDataFromApiWithParams(`buildingpermits/bulidingwithid/${permitData.agreement_id}`);
        const permitdrawing1 = await GetDataFromApiWithParams("/buildingPermits");
        setPermitDrawing(permitdrawing1);
        
        const foundPermit = permitdrawing1.find(item => item.agreement_id === permitData.agreement_id);
        setPermitdrawing2(foundPermit);

        if (allbuildingpermit && allbuildingpermit[0] && allbuildingpermit[0].coordinates) {
          const originalData = allbuildingpermit[0].coordinates;
          const distinctCoordinates = originalData.filter((obj, index, self) =>
            index === self.findIndex(item =>
              item.x === obj.x && item.y === obj.y
            )
          );

          const result = [
            distinctCoordinates[0],
            distinctCoordinates[Math.floor(distinctCoordinates.length / 4)],
            distinctCoordinates[Math.floor(distinctCoordinates.length / 2)],
            distinctCoordinates[Math.floor(3 * distinctCoordinates.length / 4)],
            distinctCoordinates[distinctCoordinates.length - 1]
          ].filter((coord, index, self) =>
            index === self.findIndex(c => c.x === coord.x && c.y === coord.y)
          );

          setCoordinateData(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    
    if (permitData.agreement_id) {
      fetchAllData();
    }
    
    if (permitData) {
      setFormData(prev => ({
        ...prev,
        serialNo: permitData.id || prev.serialNo,
        buildingPermitNo: permitData.permit_no || prev.buildingPermitNo,
        sizeOfPlot: permitData.parcel_size ? `${permitData.parcel_size}` : prev.sizeOfPlot,
        permitIssueDate: permitData.issued_on ? new Date(permitData.issued_on).toLocaleDateString() : prev.permitIssueDate,
        permitExpiryDate: permitData.expected_finishing_date ? new Date(permitData.expected_finishing_date).toLocaleDateString() : prev.permitExpiryDate,
        approvedBy: permitData.permit_issued_by || prev.approvedBy,
        checkedBy: permitData.permit_registered_by || prev.checkedBy
      }));
    }
  }, [permitData]);

  const handleDirectPrint = () => {
    if (!printRef.current) {
      alert("Print content not ready");
      return;
    }

    try {
      const printWindow = window.open('', '_blank', 'width=1200,height=900');
      
      if (!printWindow) {
        alert("Please allow pop-ups to print the certificate");
        return;
      }
      
      const certificateHTML = printRef.current.outerHTML;
      
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Building Permit Certificate - ${formData.buildingPermitNo}</title>
          <link rel="stylesheet" type="text/css" href="${window.location.origin}/path-to-your-css/BuildingPermissionCertificate.css">
          <style>
            body {
              font-family: 'Times New Roman', Times, serif;
              margin: 20px;
              padding: 20px;
            }
            .no-print {
              display: none !important;
            }
            @media print {
              @page {
                size: A4 landscape;
                margin: 15mm;
              }
            }
          </style>
        </head>
        <body>
          ${certificateHTML}
        </body>
        </html>
      `);
      
      printWindow.document.close();
      
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 500);
    } catch (error) {
      console.error("Error printing:", error);
      alert("Error printing. Please try again.");
    }
  };

  const handleSimplePDF = () => {
    if (!printRef.current) {
      alert("PDF content not ready");
      return;
    }
    
    try {
      const element = printRef.current;
      const opt = {
        margin: 0.5,
        filename: `Building_Permit_${formData.buildingPermitNo || 'Certificate'}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
      };
      html2pdf().set(opt).from(element).save();
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error generating PDF. Please try again.");
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      {/* Test button to verify button clicks are working */}
      

      {/* PRINT BUTTONS */}
      <div className="no-print" style={{
        marginBottom: '20px',
        display: 'flex',
        gap: '10px',
        justifyContent: 'flex-end',
        padding: '10px',
       
        backgroundColor: 'white'
       
      }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<PrintIcon />}
          onClick={handleDirectPrint}
          sx={{ 
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0'
            }
          }}
        >
          Print Certificate
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          startIcon={<DownloadIcon />}
          onClick={handleSimplePDF}
          sx={{ marginLeft: '10px' }}
        >
          Save as PDF
        </Button>
      </div>

      {/* CERTIFICATE CONTENT */}
      <div ref={printRef} className="certificate-container">
        {/* Keep all your existing certificate JSX here - unchanged */}
        <div className="certificate-header">
          <div className="header-top">
            <div className="left-logo">
              <div className="logo-container">
                <img src={star} alt="Star Logo" className="logo-star" />
              </div>
            </div>
            <div className="right-logo">
              <div className="logo-container">
                <img src={logo} alt="ipdc Logo" className="logo-star" />
              </div>
            </div>
          </div>
          <div className="header-bottom">
            <div>Date: {formData.date || '________________'}</div>
            <div>Serial No.: {formData.serialNo || '________________'}</div>
          </div>
          <h1 className="certificate-title">
            THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA<br />
            INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC) <br />
            <div>
              <span style={{ color: 'red', textDecoration: 'underline' }}>BUILDING CONSTRUCTION PERMISSION CERTIFICATE</span>
            </div>
          </h1>
        </div>

        <div className="certificate-body">
          <div className="two-column-layout">
            {/* LEFT COLUMN */}
            <div className="column left-column">
              <div className="permit-details">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '160px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                      }}>
                        <span className="heading"> Name of Industry Park: </span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.nameOfIndustryPark || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '25px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '2px',
                        color: '#2c3e50',
                        fontSize: '14px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading">Owner</span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.owner || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading"> Lessee's Name: </span>
                      </td>
                      <td style={{ verticalAlign: 'left' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.lesseesName || 'IPDC'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                      }}>
                        <span className="heading"> Size of plot: </span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.sizeOfPlot || '________________'} m2
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '25px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '2px',
                        color: '#2c3e50',
                        fontSize: '14px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading">Title deed's No:</span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.titleDeedNo || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading"> Address, City: </span>
                      </td>
                      <td style={{ verticalAlign: 'left' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.addressCity || '________________'}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="info-row">
                After checking the document presented, the construction is:
                <span className="permitted"> PERMITTED</span>
              </div>

              <div className="permit-details">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                      }}>
                        <span className="heading"> Building Permit No.: </span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '200px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.buildingPermitNo || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '25px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '2px',
                        color: '#2c3e50',
                        fontSize: '14px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading">Permit Issue Date:</span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '200px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.permitIssueDate || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading"> Permit Expiry Date: </span>
                      </td>
                      <td style={{ verticalAlign: 'left' }}>
                        <div style={{
                          width: '200px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.permitExpiryDate || '________________'}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="notice-section">
                <h3>Notice:</h3>
                <ol className="notice-list">
                  <li>This certificate is produced in five copies, one for the company, one for IPDC file, one for O&M DCEO one for the Design Department and one for IP branch office.</li>
                  <li>This certificate is valid with an approved A-1 paper size site plan with an authorized IPDC sign and seal.</li>
                  <li>This certificate will be canceled if the building is utilized for another purpose.</li>
                  <li>This certificate will be valid for 18 months starting from the date of issuance of this certificate.</li>
                </ol>
              </div>
            </div>

            {/* GREEN VERTICAL DIVIDER LINE */}
            <div className="vertical-divider"></div>

            {/* RIGHT COLUMN */}
            <div className="column right-column">
              <span className="heading"> Relevant Approved Documents attached : </span>
              <table className="drawings-table">
                <thead>
                  <tr className="table-row">
                    <td>Item no</td>
                    <td>Drawings</td>
                    <td></td>
                    <td>Remark</td>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { id: 1, name: 'plan_archtectural_path', label: 'Architectural' },
                    { id: 2, name: 'plan_structural_path', label: 'Structural' },
                    { id: 3, name: 'plan_electrical_path', label: 'Electrical' },
                    { id: 4, name: 'plan_sanitary_path', label: 'Sanitary' },
                    { id: 5, name: 'plan_electro_mechanical_path', label: 'Electromechanical' },
                    { id: 6, name: 'plan_environmental_path', label: 'Environmental' },
                    { id: 7, name: 'plan_other_path', label: 'Other Plans' },
                    { id: 8, name: 'telecom', label: 'Telecom' }
                  ].map((item) => {
                    const drawingValue = permitDrawing?.[item.name];
                    const hasDrawing = drawingValue && drawingValue.trim() !== '';

                    return (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.label}</td>
                        <td>
                          {hasDrawing ? '✓' : ''}
                        </td>
                        <td>
                          {hasDrawing ? 'Submitted' :
                            permitdrawing2 ? 'Pending' : 'Not Submitted'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div className="conditions-section">
                <ol className="conditions-list">
                  <li>Permitted as per the consultant, client & contractor commitment form signature</li>
                  <li>The construction has to be carried out with the approved Drawings only.</li>
                  <li>A major design amendment has to be submitted and get approval at the head office level.</li>
                </ol>
              </div>

              <div className="decision-section">
                <h3>Decision for Permission - <fa>factory Sheds and auxiliary building. </fa></h3>
              </div>

              <div className="coordinates-section">
               <span className="coordinate">Compound Location Coordinates</span> 
                <table className="coordinates-table">
                  <tr>
                    <td>X</td>
                    <td>Y</td>
                  </tr>
                  <tbody>
                    {coordinateData.map((coord, index) => (
                      <tr key={index}>
                        <td>{coord.x}</td>
                        <td>{coord.y}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="authority-section">
          <p className="authority-text">
            This Building Permission Certificate is given to the above stated company by the IPDC as per the delegation of Authority from Ethiopian Investment Commission (EIC) in Mar, 04, 2016, concerning Issuance of construction and / or occupancy Permits.
          </p>
        </div>
        <div className="signatures-section">
          <div className="signature-row">
            <div className="signature-column">
              <div className="signature-label">Checked by:</div>
              <div className="signature-line">_________________________</div>
              <div style={{ fontSize: '11px', marginTop: '5px' }}>{formData.checkedBy}</div>
            </div>

            <div className="signature-column">
              <div className="signature-label">Certified by:</div>
              <div className="signature-line">_________________________</div>
              <div style={{ fontSize: '11px', marginTop: '5px' }}>{formData.approvedBy}</div>
            </div>

            <div className="signature-column">
              <div className="signature-label">Approved by:</div>
              <div className="signature-line">_________________________</div>
              <div style={{ fontSize: '11px', marginTop: '5px' }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildingPermissionCertificate;